import z from "zod";

export const contactSchema = z.object({
  title: z.string(),
  name: z.string(),
  email: z.string().optional(),
  phone: z.string().optional(),
  address: z.string(),
  address2: z.string().optional(),
  postalNumber: z.string(),
  city: z.string(),
  primary: z.boolean(),
  showInFooter: z.boolean(),
});

export type Contact = z.infer<typeof contactSchema>;
